/*
* @desc 基于坐标的散点图
* @author xuyao
*/
import React, { PureComponent } from 'react';
import extend from './utils/extend';
import EchartBase from './base/EchartBase';
import { createStandardData } from './utils/util';
import { colors, tooltipStyles } from './config/config';

class BBDAxisScatter extends PureComponent {
    constructor(props) {
        super(props);
    }

    setOption(param){
        let {
            color = colors.color.slice(),
            data = [],
            symbolSize = 10,
            ...others
        } = param;

        const baseSeries = {    // 默认配置
            type: 'scatter',
            symbolSize
        };

        let series = createStandardData(data, baseSeries);

        const option = {
            color,
            title: {
                text: '',
                padding: [10, 0, 0, 10],
                textStyle: {
                    fontSize: 16,
                    fontWeight: 'normal',
                    fontFamily: 'Microsoft Yahei'
                }
            },
            grid: {
                top: 15,
                left: 10,
                right: 50,
                bottom: 15,
                containLabel: true
            },
            tooltip: {
                padding: [10, 10, 10, 10],
                formatter: function(data){
                    return false;
                },
                ...tooltipStyles
            },
            xAxis: [{
                name: ' ',
                type: 'value',
                boundaryGap: false,
                axisLine: {
                    lineStyle: {
                        color: colors.axisLineColor
                    }
                },
                axisLabel: {
                    color: colors.textColor,
                    textStyle: {
                        fontSize: 12,
                        fontFamily: 'Microsoft Yahei'
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#DDE0E5'
                    }
                }
            }],
            yAxis: [{
                name: '',
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: colors.axisLineColor
                    }
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: colors.textColor,
                    textStyle: {
                        fontSize: 12,
                        fontFamily: 'Microsoft Yahei'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: colors.splitLineColor
                    }
                }
            }],
            series: series
        };
        let op = extend(true, {}, option, others);
        return op;
    }
    render() {
        return (
            <EchartBase onEvents={this.props.onEvents} option={this.setOption(this.props.option)} style = {this.props.style} />
        );
    }
}
export default BBDAxisScatter;



// WEBPACK FOOTER //
// ./src/components/common/echarts/BBDAxisScatter.jsx